module.exports = __webpack_public_path__ + "img/IT0000111060517.160b8093.png";